export default __webpack_public_path__ + "static/media/tile-des1-en-pick-mode.8bd6e115.gif";